import React, { useState } from "react";

import { Grid } from "@mui/material";
import { FormButton, SpinnerOverlay } from "components";
import { FormikTextInput } from "components/UI/Inputs/FormikInputs";

import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { snackbarData, userCredentials } from "recoilState/GlobalState";

import { FORM_ERROR_MESSAGES } from "consts/errorMessages";
import { mensajeLargo } from "consts/limites-campos";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHHorarioIns } from "services/services-mia/programa-salud/personal/RNHHorarioIns";
import { codRegex, LARGO_HORARIO } from "../consts";

/**
 * Alta de un horario: código, nombre y descripción. Los rangos no se cargan acá; se
 * agregan después desde el botón "Rangos horarios" de la grilla.
 *
 * El servicio acepta además tipo, vigencia y "es default". No se mandan a propósito:
 * la pantalla no los muestra, y para este servicio omitir un campo es no informarlo.
 */
export default function InsertModal({ updateList, closeModal }) {
    const setSnackbarInfo = useSetRecoilState(snackbarData);
    const credentials = useRecoilValue(userCredentials);
    const [inRequest, setInRequest] = useState(false);

    const handleSubmit = async (values) => {
        setInRequest(true);
        const respuesta = await RNHHorarioIns(credentials, {
            cod: values.cod,
            nombre: values.nombre,
            descripcion: values.descripcion,
        });
        setInRequest(false);

        // El snackbar de error ya lo muestra el interceptor de axiosPost.
        if (!respuesta.ok) return;

        setSnackbarInfo({
            message: "Horario creado correctamente",
            severity: "success",
            open: true,
        });
        updateList();
        closeModal();
    };

    return (
        <Formik
            initialValues={{ cod: "", nombre: "", descripcion: "" }}
            validationSchema={yup.object({
                cod: yup
                    .string()
                    .max(LARGO_HORARIO.cod, mensajeLargo(LARGO_HORARIO.cod))
                    .matches(codRegex, "Debe tener solo letras y/o números")
                    .required(FORM_ERROR_MESSAGES.required),
                // Nombre y descripcion son TEXTO LIBRE: solo largo y requerido, como el
                // resto de los ABM del modulo. No se valida el juego de caracteres.
                nombre: yup
                    .string()
                    .max(LARGO_HORARIO.nombre, mensajeLargo(LARGO_HORARIO.nombre))
                    .required(FORM_ERROR_MESSAGES.required),
                descripcion: yup
                    .string()
                    .max(LARGO_HORARIO.descripcion, mensajeLargo(LARGO_HORARIO.descripcion))
                    .required(FORM_ERROR_MESSAGES.required),
            })}
            onSubmit={handleSubmit}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <Grid
                        container
                        rowSpacing={0}
                        columnSpacing={2}
                        sx={{
                            width: "100%",
                            // El hueco del error ya lo reserva FormikInputs; el margin
                            // propio del TextField solo sumaba separación.
                            "& .MuiFormControl-root": { marginTop: 0, marginBottom: 0 },
                        }}
                    >
                        <Grid item xs={4}>
                            <FormikTextInput
                                fullWidth
                                name="cod"
                                labelText="Código"
                                inputProps={{ maxLength: LARGO_HORARIO.cod }}
                                // El código es una clave: un espacio adentro la parte en dos.
                                onKeyDown={(e) => {
                                    if (e.key === " ") e.preventDefault();
                                }}
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <FormikTextInput
                                fullWidth
                                name="nombre"
                                labelText="Nombre"
                                inputProps={{ maxLength: LARGO_HORARIO.nombre }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <FormikTextInput
                                fullWidth
                                name="descripcion"
                                labelText="Descripción"
                                inputProps={{ maxLength: LARGO_HORARIO.descripcion }}
                            />
                        </Grid>
                    </Grid>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Agregar" }}
                        onCloseModal={closeModal}
                    />
                    {inRequest && <SpinnerOverlay />}
                </div>
            </Form>
        </Formik>
    );
}
